import { requireAuth } from '@/lib/auth'
import { createFileRoute, Outlet } from '@tanstack/react-router'
import { Toaster } from 'sonner'
import { ApplicationShell } from '@/components/layout/application-shell/application-shell'

export const Route = createFileRoute('/_auth')({
  beforeLoad: async ({ location }) => {
    await requireAuth(location.href)
  },
  component: AuthenticatedLayout,
})

function AuthenticatedLayout() {
  return (
    <ApplicationShell>
      <div className="flex flex-col h-full p-6 gap-4">
        <Outlet />
        <Toaster richColors closeButton />
      </div>
    </ApplicationShell>
  )
}
